module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_orange_01-740302fb1801a21cb23818e98d4535e5.svg";